import { render, staticRenderFns } from "./StockAddDialogButton.vue?vue&type=template&id=45cacf6a&"
import script from "./StockAddDialogButton.vue?vue&type=script&lang=ts&"
export * from "./StockAddDialogButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports